/**
 * 新增修改完成调用 modalFormOk方法 编辑弹框组件ref定义为modalForm
 * 高级查询按钮调用 superQuery方法  高级查询组件ref定义为superQueryModal
 * data中url定义 list为查询列表  delete为删除单条记录  deleteBatch为批量删除
 */
import { filterObj } from '@/utils/util'
import { deleteAction, getAction, postAction, downFile } from '@/api/manage'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import context from '@/main.js'

export const tableMixin = {
  data() {
    return {
      requestType: 'get',
      forceClear: false,
      //token header
      tokenHeader: {
        'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)
      },
      /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
      queryParam: {},
      url: {},
      /* 数据源 */
      dataSource: [],
      selectionRowsDump: [],
      /* 分页参数 */
      pageSizeCacheKey: 'pageSize',
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => {
          // return range[0] + "-" + range[1] + " 合" + total + "件"
          return (
            <span style="position: relative; top: 1px;">
              合计<span style="color: var(--color-primary); letter-spacing: 1px;">{'　' + total + '　'}</span>条
            </span>
          )
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      /* 排序参数 */
      isorter: {
        //column: 'updateTime',
        //order: 'desc'
        column: '',
        order: ''
      },
      /* 筛选参数 */
      filters: {},
      /* table加载状态 */
      loading: false,
      showLoadingBySearch: false,
      /* table选中keys*/
      selectedRowKeys: [],
      /* table选中records*/
      selectionRows: [],
      /* 查询折叠 */
      toggleSearchStatus: false,
      /* 高级查询条件生效状态 */
      superQueryFlag: false,
      /* 高级查询条件 */
      superQueryParams: '',
      columnsEdited: false,
      isExport: false,
      disableMixinSearchQuery: false,
      disableMixinQueryParamWatch: false,
      exportFileName: '',
      headerField: [],
      headerText: [],
      pageNoBk: 1,
      debounceControl: false,
      //是否已执行查询
      isDoneSearchQuery: false,
    }
  },
  created() {
    //if (!this.columnsEdited && this.columns) {
    //  for (var i = 0; i < this.columns.length; i++) {
    //    if (!this.columns[i].ellipsis && !this.columns[i].scopedSlots) {
    //      this.columns[i].ellipsis = true
    //    }
    //  }
    //  this.columnsEdited = true
    //}
    this.ipagination.pageSize =
      localStorage[this.pageSizeCacheKey] == undefined ? 10 : Number(localStorage[this.pageSizeCacheKey])
  },
  mounted() {
    if (!this.disableMixinSearchQuery) {
      if (!this.debounceControl) {
        this.debounceControl = true
        this.searchQuery(false, true)
      }
    }
  },
  updated() {},
  watch: {
    queryParam: {
      handler(newVal, oldVal) {
        if(!this.disableMixinQueryParamWatch){
          if (!this.debounceControl) {
            this.searchQueryDebounce(false, true)
          }
        }
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    // 具有防抖的检索
    searchQueryDebounce: XEUtils.debounce(
      function(keepPage, keepSelected) {
        this.searchQuery(keepPage, keepSelected)
      },
      200,
      {
        leading: false,
        trailing: true
      }
    ),
    /**
     * 检索处理
     * @method
     * @param {boolean} keepPage 是否保持翻页状态
     * @param {boolean} keepSelected 是否保持已选择项
     */
    searchQuery(keepPage, keepSelected) {
      if (this.callbackBeforeSearchQuery) {
        this.callbackBeforeSearchQuery(keepPage, keepSelected)
      }

      if (!this.url.list) {
        return
      }

      if (!window.dataFilterUrl && this.$options.name) {
        window.dataFilterUrl = this.$options.name
      }

      // 开启了loading模式
      if (this.showLoadingBySearch) {
        // 未处于loading则开启loading
        if (!this.loading) {
          this.loading = true
        }
      }

      // 不保持翻页状态 且 非导出的时候
      if (!keepPage && !this.isExport) {
        this.ipagination.current = 1
      }

      // 不保持已选择项
      if (!keepSelected) {
        this.onClearSelected()
      }

      //查询条件
      var params = this.getQueryParams()
      this.modifyExportParams(params)

      if (this.isExport) {
        //CSV出力処理
        downFile(this.url.list, params, this.requestType == 'post' ? 'post' : null)
          .then(res => {
            this.downloadStream(res)
          })
          .finally(() => {
            this.loading = false
            this.isExport = false
            this.ipagination.current = this.pageNoBk
            window.dataFilterUrl = undefined
          })
      } else {
        if (this.requestType == 'post') {
          postAction(this.url.list, params)
            .then(res => {
              if (res.success) {
                if (!res.result) {
                  return
                }

                if (res.result.records.length == 0 && res.result.total > 0 && this.ipagination.current > 1) {
                  this.ipagination.current = this.ipagination.current - 1
                  this.searchQuery(true, false)
                  return
                }

                this.dataSource = res.result.records
                this.ipagination.total = res.result.total

                this.isDoneSearchQuery = true

                if (this.callbackAfterSearchQuery) {
                  this.callbackAfterSearchQuery(res.result.records)
                }
              }
            })
            .finally(() => {
              this.loading = false
              this.debounceControl = false
              window.dataFilterUrl = undefined
            })
        } else {
          getAction(this.url.list, params)
            .then(res => {
              if (res.success) {
                if (!res.result) {
                  return
                }

                let records = res.result.records || res.result
                let total = res.result.total || res.result.length

                if (records.length == 0 && total > 0 && this.ipagination.current > 1) {
                  this.ipagination.current = this.ipagination.current - 1
                  this.searchQuery(true, false)
                  return
                }

                this.dataSource = records
                this.ipagination.total = total

                this.isDoneSearchQuery = true

                if (this.callbackAfterSearchQuery) {
                  this.callbackAfterSearchQuery(records)
                }
              }
            })
            .finally(() => {
              this.loading = false
              this.debounceControl = false
              window.dataFilterUrl = undefined
            })
        }
      }
    },
    searchReset() {
      this.queryParam = {}
    },
    addRow(target) {
      if (!target) {
        var target = this.form.dataSource || this.dataSource
      }

      target.push({})
    },
    deleteRow(target, index) {
      if (!target) {
        var target = this.form.dataSource || this.dataSource
      }

      XEUtils.remove(target, index)
    },
    deleteAllRows(target) {
      if (!target) {
        var target = this.form.dataSource || this.dataSource
      }

      XEUtils.remove(target)
      this.$forceUpdate()
    },
    upRow(dataSource, index) {
      if (index != 0) {
        dataSource[index] = dataSource.splice(index - 1, 1, dataSource[index])[0]
      } else {
        dataSource.push(dataSource.shift())
      }
    },
    downRow(dataSource, index) {
      if (index != dataSource.length - 1) {
        dataSource[index] = dataSource.splice(index + 1, 1, dataSource[index])[0]
      } else {
        dataSource.unshift(dataSource.splice(index, 1)[0])
      }
    },
    enableMoveRow(callback, target) {
      if (document.querySelectorAll('.ant-table-tbody').length > 0) {
        document.querySelectorAll('.ant-table-tbody').forEach(target => {
          var trigger = undefined
          Sortable.create(target, {
            sort: true,
            forceFallback: false,
            handle: '.j-sort',
            group: { name: 'name', pull: false, put: false },
            onStart: function(evt) {
              target.classList.add('drag-sort-ing')
              document.querySelectorAll('.ant-table-row-hover').forEach(tr => {
                tr.classList.remove('ant-table-row-hover')
              })
              trigger = evt.item
            },
            onEnd({ newIndex, oldIndex }) {
              target.classList.remove('drag-sort-ing')
              trigger.closest('.ant-table-row').classList.add('ant-table-row-hover')

              if (callback) {
                callback(newIndex, oldIndex)
              }
            }
          })
        })
      }
    },
    copyRow(dataSource, index) {
      var target = dataSource[index]
      var newRow = XEUtils.clone(target, true)

      if (newRow.id) {
        newRow.id = undefined
      }

      if (!XEUtils.isUndefined(newRow.rowIndex)) {
        newRow.rowIndex = newRow.rowIndex + 1
      }

      dataSource.push(newRow)
    },
    modifyExportParams(params) {
      params.isExport = this.isExport

      if (this.isExport) {
        //this.headerField = []
        //this.headerText = []

        //if (this.columns && this.columns.length > 0) {
        //  this.columns.forEach(colomn => {
        //    if (colomn.noExport) {
        //    } else {
        //      if (colomn.dataIndex && !this.headerField.includes(colomn.dataIndex)) {
        //        this.headerField.push(colomn.dataIndex)
        //      }

        //      if (colomn.title && !this.headerText.includes(colomn.title)) {
        //        this.headerText.push(colomn.title)
        //      }
        //    }
        //  })
        //} else {
        //  var tempHeader = []
        //  document.querySelectorAll('th[key]:not(.noExport)').forEach(colomn => {
        //    if (
        //      colomn.getAttribute('key') &&
        //      isNaN(Number(colomn.getAttribute('key'))) &&
        //      !this.headerField.includes(colomn.getAttribute('key'))
        //    ) {
        //      this.headerField.push(colomn.getAttribute('key'))
        //      tempHeader.push({
        //        key: colomn.getAttribute('key'),
        //        left: colomn.getBoundingClientRect().left
        //      })
        //    }
        //  })

        //  tempHeader = XEUtils.sortBy(tempHeader, 'left')
        //  this.headerField = []
        //  tempHeader.forEach(temp => {
        //    this.headerField.push(temp.key)

        //    var colomn = document.querySelector('th[key="' + temp.key + '"]')
        //    if (colomn && colomn.textContent && !this.headerText.includes(colomn.textContent)) {
        //      temp.key.split(',').forEach(element => {
        //        this.headerText.push(colomn.textContent)
        //      })
        //    }
        //  })
        //}

        //params.headerField = this.headerField.join(',')
        //params.headerText = this.headerText.join(',')

        if (sessionStorage['dictCode_max_export_rows']) {
          params.pageSize = JSON.parse(sessionStorage['dictCode_max_export_rows'])[0].value
        } else {
          params.pageSize = 999999999
        }

        params.pageNo = 1
        this.pageNoBk = this.ipagination.current
      }
    },
    getQueryParams() {
      //获取查询条件
      let sqp = {}
      if (this.superQueryParams) {
        sqp['superQueryParams'] = encodeURI(this.superQueryParams)
      }
      var param = Object.assign(sqp, this.queryParam, this.isorter, this.filters)
      //param.field = this.getQueryField()
      param.pageNo = this.ipagination.current
      param.pageSize = this.ipagination.pageSize

      return filterObj(param)
    },
    //getQueryField() {
    //  var str = 'id,'
    //  this.columns.forEach(function(value) {
    //    str += ',' + value.dataIndex
    //  })
    //  return str
    //},
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys

      var table = event.target.closest('.ant-table').__vue__.$children[0].table

      if (!table) {
        table = event.target.closest('.ant-table').__vue__.$children[0].$refs.table
      }

      if (!table) {
        return
      }

      var rowKey = table.rowKey
      selectionRows.forEach(data => {
        if (!XEUtils.find(this.selectionRowsDump, item => item[rowKey] == data[rowKey])) {
          this.selectionRowsDump.push(data)
        }
      })

      this.selectionRows = []
      this.selectedRowKeys.forEach(key => {
        var dump = XEUtils.filter(this.selectionRowsDump, item => item[rowKey] == key)
        if (dump && dump.length > 0) {
          this.selectionRows.push(dump[0])
        }
      })

      if (this.selectChangeCallback) {
        this.selectChangeCallback()
      }
    },
    onClearSelected() {
      this.selectedRowKeys = []
      this.selectionRows = []
      this.selectionRowsDump = []
    },
    batchDel: function() {
      if (!this.url.deleteBatch) {
        this.$message.error(this.$t('disp.setUrlDeleteBatch'))
        return
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning(this.$t('disp.rules.select'))
        return
      } else {
        var ids = ''
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        var that = this
        this.$confirm({
          title: this.$t('disp.warn'),
          content: this.$t('msg.confirm.deleteBatch'),
          onOk: function() {
            if (that.loading) {
              return
            } else {
              that.loading = true
            }

            deleteAction(that.url.deleteBatch, {
              ids: ids
            })
              .then(res => {
                if (res.success) {
                  that.$message.success(that.$t(res.message))
                  that.searchQuery(true, false)
                }
              })
              .finally(() => {
                that.loading = false
              })
          }
        })
      }
    },
    handleDelete: function(id) {
      if (!this.url.delete) {
        this.$message.error(this.$t('disp.setUrlDelete'))
        return
      }
      var that = this
      deleteAction(that.url.delete, {
        id: id
      }).then(res => {
        if (res.success) {
          that.$message.success(that.$t(res.message))
          that.searchQuery(true, false)
        }
      })
    },
    handleRemove: function(id) {
      if (!this.url.remove) {
        this.$message.error('请设置url.remove属性!')
        return
      }
      var that = this
      deleteAction(that.url.remove, {
        id: id
      }).then(res => {
        if (res.success) {
          that.$message.success(that.$t(res.message))
          that.searchQuery(true, false)
        }
      })
    },
    rowClassName(record) {
      if (parseInt(record.delFlag) == 1) {
        return 'ant-table-row-disabled'
      } else {
        return ''
      }
    },
    handleEdit: function(record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = this.$t('disp.btn.edit')
      this.$refs.modalForm.disableSubmit = false
    },
    handleAdd: function() {
      this.$refs.modalForm.add()
      this.$refs.modalForm.title = this.$t('disp.btn.add')
      this.$refs.modalForm.disableSubmit = false
    },
    handleTableChange(pagination, filters, sorter) {
      //保存pageSize,使之成为默认值
      localStorage[this.pageSizeCacheKey] = pagination.pageSize
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        if (sorter.order) {
          this.isorter.column = sorter.field
          this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc'
        } else {
          this.isorter.column = ''
          this.isorter.order = ''
        }
      }
      this.ipagination = pagination
      this.searchQuery(true, true)

      if (this.handleTableChangeCallback) {
        this.handleTableChangeCallback()
      }
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    modalFormOk() {
      // 新增/编辑 成功时
      // 重载列表 且 保持在当前页 且 保持选择状态
      this.searchQuery(true, true)
    },
    handleDetail: function(record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = this.$t('disp.flow.detail')
      this.$refs.modalForm.disableSubmit = true
    },
    downloadStream(stream) {
      let url = window.URL.createObjectURL(new Blob([stream]))
      // 生成一个a标签
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      // 生成时间戳
      let timestamp = new Date().format('yyyyMMddhhmmssS')

      var fileName = $getTextByLocale(this.$route.meta.title)
      if (this.exportFileName) {
        fileName = this.exportFileName
      }

      link.download = fileName + '_' + timestamp + '.csv'
      document.body.appendChild(link)
      link.click()
    },
    handleExportXls2() {
      let paramsStr = encodeURI(JSON.stringify(this.getQueryParams()))
      let url = `${window._CONFIG['domianURL']}/${this.url.exportXlsUrl}?paramsStr=${paramsStr}`
      window.location.href = url
    },
    handleExportXls(fileName) {
      if (!fileName || typeof fileName != 'string') {
        fileName = '导出文件'
      }
      let param = {
        ...this.queryParam
      }
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        param['selections'] = this.selectedRowKeys.join(',')
      }
      console.log('导出参数', param)
      downFile(this.url.exportXlsUrl, param).then(data => {
        if (!data) {
          this.$message.warning('文件下载失败')
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], {
              type: 'application/vnd.ms-excel'
            }),
            fileName + '.xls'
          )
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], {
              type: 'application/vnd.ms-excel'
            })
          )
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName + '.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象
        }
      })
    },
    /* 图片预览 */
    getImgView(text) {
      if (text && text.indexOf(',') > 0) {
        text = text.substring(0, text.indexOf(','))
      }
      return window._CONFIG['staticDomainURL'] + '/' + text
    },
    /* 文件下载 */
    uploadFile(text) {
      if (!text) {
        this.$message.warning('未知的文件')
        return
      }
      if (text.indexOf(',') > 0) {
        text = text.substring(0, text.indexOf(','))
      }
      window.open(window._CONFIG['staticDomainURL'] + '/' + text)
    },
    /**
     * 自定义导入文件方法
     * @param data 上传的 excel 文件
     */
    customRequest(data, url) {
      if (!url && !this.url.import) {
        this.$message.error('请设置url.import属性!')
        return
      }

      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      const file = data.file // 需要上传的 excel 文件
      const formData = new FormData()
      formData.append('file', file)
      postAction((url || this.url.import) + '?', formData)
        .then(res => {
          if (res.success) {
            this.$message.success('导入成功')
            this.searchQuery(true, false)
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}

